<template>
	<div class="foot clearfix">
		<div class="back">
			<i @click='back'></i>
		</div>
		<div class="reload">
			<i @click='reload'></i>
		</div>
		<div class="home">
			<i @click='home'></i>
		</div>
	</div>
</template>
<script>
	export default {
	  name: 'head',
	  data(){
	  	return{
	  		
	  	}
	  },
	  mounted:function(){
	  	
	  },
	  methods:{
	  	back:function(){
	  		window.history.go(-1)
	  	},
	  	reload:function(){
	  		window.location.reload()
	  	},
	  	home:function(){
	  		this.$router.push('/')
	  	}
	  }
	  
	}
</script>
<style scoped>
	.foot{
		height: 0.94rem;
		line-height: 0.94rem;
		background-color: #8b8b8c;
		position: fixed;
		width: 100%;
		left: 0;
		bottom: 0;
		text-align: center;
		z-index: 99;
	}
	.foot i{
		display: inline-block;
	    background-image: url(../../../static/images/icons.png);
	    background-size: 3.24rem 2.51rem;
	    /* position: absolute;
	    top: 50%;
	    left: 50%;
	    transform: translate(-50%,-50%); */
	}
	.foot .back{
		float: left;
		width: 50%;
		position: relative;
		height: 100%;
	}
	.foot .back i{
		width: 0.52rem;
		height: 0.44rem;
		background-position: -0.1rem -1.45rem;
		position: absolute;
	    top: 50%;
	    left: 40%;
	    transform: translate(-60%,-50%);
	}
	.foot .reload i{
		width: 0.53rem;
		height: 0.52rem;
		background-position: -1.45rem -0.1rem;
		position: absolute;
	    top: 50%;
	    left: 60%;
	    transform: translate(-50%,-50%);
	}
	.foot .reload{
		float: left;
		width: 50%;
		height: 100%;
		position: relative;
	}
	.foot .home{
		position: absolute;
		 top: 0%;
	    left: 50%;
	    transform: translate(-50%,-30%);
	}
	.foot .home i{
		width: 1.15rem;
		height: 1.15rem;
		background-position: -0.1rem -0.1rem;
		
	}
</style>


// WEBPACK FOOTER //
// src/components/public/foot.vue